import React from 'react';
import PropTypes from 'prop-types';
import PostingTimeTooltip from './PostingTimeTooltip';

function MerchantDescriptionBasic({ merchant, config }) {
  const {
    name, rebate = {}, description, disclaimer, daysToPostTimeboundText, isDirect,
  } = merchant;
  const { termsTitle, directMerchantName, directMerchantDescription } = config;

  return (
    <div className="mn_merchantDescriptionBasic" data-test="merchant-description">
      {isDirect &&
        <>
          <div className="mn_h3">{directMerchantName}</div>
          <p className="mn_merchantDescriptionText">{directMerchantDescription}</p>
        </>
      }
      <div className="mn_h3">About {name}</div>
      <p className="mn_merchantDescriptionText">{description}</p>
      {daysToPostTimeboundText &&
        <div>
          <div className="mn_h3">
            <span>Estimated posting time</span>
            <PostingTimeTooltip />
          </div>
          <p className="mn_merchantDescriptionPostingTime">{daysToPostTimeboundText}</p>
        </div>
      }
      {(rebate.disclaimer || disclaimer) &&
        <div className="mn_terms" id="merchantDisclaimer" data-test="merchant-terms">
          <div className="mn_h4">{termsTitle}</div>
          <p
            className="mn_merchantTerms"
            dangerouslySetInnerHTML={{
              __html: `Please note these terms & conditions: ${rebate.disclaimer} ${disclaimer}`,
            }}
          />
        </div>
      }
    </div>
  );
}

MerchantDescriptionBasic.propTypes = {
  merchant: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({}),
};

MerchantDescriptionBasic.defaultProps = {
  config: {},
};

export default MerchantDescriptionBasic;
